import axios from "axios";
import API_BASE_URL from "../../../config/apiConfig";

const API_URL = `${API_BASE_URL}/api/Management/users/reset-password`;

const resetPassword = async (idEmployee, newPassword) => {
  try {
    const response = await axios.put(API_URL, { idEmployee, newPassword }, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
    });
    return response.data;
  } catch (error) {
    console.error("Error al resetear la contraseña:", error.response?.data || error.message);
    throw error;
  }
};

export default resetPassword;
